module.exports = __webpack_public_path__ + "static/img/cardbg4.b64c8d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardbg4.png
// module id = SUBA
// module chunks = 1